import { UserComponent } from 'react/UserComponent.jsx';
import React, { useCallback, useRef, useState } from 'react';
import ReactToolTip from 'react-tooltip';

import { TimeHolderComponent } from 'react/chat/inner/display_pieces/messages/TimeHolderComponent.jsx';
import { PlayerMessageTextComponent } from 'react/chat/inner/display_pieces/messages/PlayerMessageTextComponent.jsx';
import { ReactionPillsComponent } from 'react/chat/inner/display_pieces/messages/ReactionPillsComponent.jsx';
import { ChatNotificationReportComponent } from 'react/chat/inner/display_pieces/messages/notifications/ChatNotificationReportComponent.jsx';
import { HealthComponent } from 'react/chat/inner/display_pieces/messages/HealthComponent.jsx';
import CharacterStockIcon from 'react/chat/inner/display_pieces/messages/CharacterStockIcon';
import ChatAvatar from 'react/chat/inner/display_pieces/messages/ChatAvatar';
import MessageHoverToolbar, { QUICK_REACTION_EMOJI } from 'react/chat/inner/display_pieces/messages/MessageHoverToolbar';
import LfgCard from 'react/chat/inner/display_pieces/messages/kinds/LfgCard';
import ConnectCodeOfferCard from 'react/chat/inner/display_pieces/messages/kinds/ConnectCodeOfferCard';
import senderStockCharacter from 'react/chat/inner/display_pieces/messages/senderStockCharacter';

import store from 'react/redux/store/store';
import * as popupActions from 'react/redux/actions/popups';
import { userProfileOpen } from 'react/redux/actions/popups';
import { LadderLinker } from 'components/LadderLinker';
import useWavesEffect from "../../../../hooks/useWavesEffect";
import { ChatRoom } from "models/ChatRoom";
import withDefaultProps from 'functions/withDefaultProps';
import { formatLadderTime } from 'react/elements/LadderTime';
import { sentByMatchModerator } from 'react/match/moderation/matchModeration';
import { __ } from 'i18n/index';


export default function ChatMessageComponent(incomingProps) {
	const props = withDefaultProps(incomingProps, defaultProps);
	const {
		message,
		isDeleteHighlighted,
		displayMannersWarning,
		displayScamWarning,
		isEditing,
		chatMessages,
		showFrontFlair,
		showFlair,
		submittingUpdate,
		endChatMessageEditMode,
		submitMessageEdit,
		setChatMessageToEditMode,
		showCalendarTime,
		isPreview,
		isHoverHighlighted,
		isFocused,
		sendFailed,
		style,
		isMobile
	} = props;

	const ref = useRef(null);
	const [resending, setResending] = useState(false);

	const classes = useWavesEffect(ref, isMobile && !isEditing);

	const onContextMenu = useCallback((e) => {
		messageClicked('message', e);
	}, [message]);

	const onTimeHolderClick = useCallback((e) => {
		if(!message) {
			return;
		}
		messageClicked('time_holder', e);
	}, [message]);

	const onMessageClicked = useCallback(() => {
		if(!message.sendFailed) {
			return;
		}
		setResending(true);
		message.send().finally(() => {
			setResending(false);
		});
	}, [message]);

	const launchContextMenu = useCallback((e) => {
		store.dispatch(popupActions.chatMessageContextMenu(message, { x: e.nativeEvent.x, y: e.nativeEvent.y }, e));
	}, [message]);

	const messageClicked = useCallback((elementName, e) => {
		if(e.type === 'contextmenu') {
			if(e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'a') {
				return;
			}
			launchContextMenu(e);
		} else if(e.type === 'click') {
			if(elementName === 'time_holder') {
				launchContextMenu(e);
			}
		}
	}, [message]);

	const chatUsernameClick = useCallback((e) => {
		const data = {
			id: message.player && message.player.id,
			chat_room_id: message.chatMessages.chatRoomId,
			chat_message_id: message.id,
		};
		store.dispatch(userProfileOpen(message.player, { x: e.nativeEvent.pageX, y: e.nativeEvent.pageY }, data));
	}, [message]);

	const quickReact = useCallback(() => {
		message.toggleReaction(QUICK_REACTION_EMOJI);
	}, [message]);

	const messageShouldNotDisplay = useCallback(() => {
		return (
			(<div className='chat_message'>
				This is not actually displayed
			</div>)
		);
	}, []);

	if(message.isNotification) {
		return <ChatNotificationReportComponent chatMessage={message} />;
	}

	classes.add('chat_message');
	classes.add('normal_message');
	classes.add(`user_id_${message.player.id}`);
	classes.add(`user_listed_${message.player.usernameLowercase}`);
	classes.add(`message_id_${message.id}`);
	const messageData = message;

	if(message.message.startsWith('/me ')) {
		message.meTexted = true;
		classes.add('me_texted');

		const classMap = new Map();
		message.player.addColorPreferenceClasses(classMap);
		classMap.forEach((title, className) => {
			classes.add(className);
		});
	}
	if(messageData.isModOfMessage) {
		classes.add('is_mod_of_message');
	}

	if(message.player === myUser) {
		classes.add('is_me');
	}
	// A moderator who joined a match chat: tagged MOD with a blue rail.
	const fromMatchModerator = sentByMatchModerator(chatMessages, message);
	if(fromMatchModerator) {
		classes.add('chat_message--moderator');
	}
	if(messageData.edited) {
		classes.add('edited');
	}

	if(messageData.previousMessageHasSameOwner) {
		classes.add('same_player_as_previous');
	}

	if(isDeleteHighlighted) {
		classes.add('delete_highlight');
	}


	if(sendFailed) {
		classes.add('send_failed');
		//title Click to Resend???
	}
	if(!messageData.id) {
		classes.add('my_temp_message');
	}

	if(message.player.is_birthday) {
		classes.add('is_birthday');
	}
	if(myUser.is_ladder_mod) {
		if(message.behavior_issues) {
			classes.add('is_hitlisted');
		}
	}

	if(message.isUpdating) {
		classes.add('update_action');
	}

	if(messageData.hasMentionFor(myUser)) {
		classes.add('you_were_mentioned');
	}

	if(messageData.is_shadow_muted) {
		if(messageData.isModOfMessage) {
			classes.add('is_shadow_muted');
		}
	}
	const isIgnored = myUser.ignore_list[message.player.id];
	if(isIgnored) {
		if(!messageData.isModOfMessage) {
			return messageShouldNotDisplay();
		}
	}

	const isMyMessage = message.isMyMessage();
	if(messageData.isModOfMessage || isMyMessage) {
		classes.add('is_mod_of_message');
	}
	if(isIgnored) {
		classes.add('is_ignored');
	}
	if(messageData.is_muted) {
		if(messageData.isModOfMessage) {
			if(isIgnored) {
			} else if(!message.player.isMe()) {
				return messageShouldNotDisplay();
			} else {
				classes.add('is_muted');
			}
		} else {
			if(!message.player.isMe()) {
				return messageShouldNotDisplay();
			}
		}
	}

	if(isHoverHighlighted) {
		classes.add('hover_highlight');
	}

	if(isFocused) {
		classes.add('chat_message--focused');
	}

	if(isPreview) {
		classes.delete('normal_message');
		classes.delete('same_player_as_previous');
	}

	let title = null;

	let messageReact = message.messageReact;
	if(message.deleted) {
		classes.add('deleted');
		classes.delete('edited');
		if(message.isSelfDeleted()) {
			if(messageData.isModOfMessage && message.message) {

				title = message.message;
			} else {
				messageReact = 'Self_PikaCHEWED';

			}
		} else {
			classes.add('mod_deleted');
			if(messageData.isModOfMessage && message.message) {
				title = message.message;
			} else {
				messageReact = 'message_pikaCHEWED';
			}
		}
	}

	if(isEditing) {
		classes.add('editing');
	}

	const senderMain = senderStockCharacter(message, chatMessages);
	const showToolbar = !!message.id && !message.deleted && !isPreview && !isEditing && !sendFailed;
	// An LFG card replaces the text (it is not editable); deleted cards keep the chewed text.
	const lfg = message.getLfg && !message.deleted ? message.getLfg() : null;
	const connectCodeOffer = isMyMessage && !lfg ? chatMessages?.connectCodeOfferFor?.(message) : null;
	if(lfg) {
		classes.add('chat_message--lfg');
	}

	return (
		<React.Fragment>
			{sendFailed &&
			<div
				className='chat_message clickable hoverable error'
				onClick={onMessageClicked}
			>
				{!resending &&
				<span
					className='send_failed_reason'>{message.sendFailedReason ? message.sendFailedReason : 'Message Failed To Send, click to retry'}</span>
				}
				{resending &&
				<span className='send_failed_reason'>Retrying...</span>
				}
			</div>
			}
			<div
				ref={ref}
				title={title}
				onContextMenu={onContextMenu}
				style={style}
				className={classes.toString()}
				data-id={message.id}
				onClick={onMessageClicked}

			>
	                <span className='delete_holder'>
	                    <i className='fa fa-times delete' />
	                    <i className='fa fa-times undelete' />
	                </span>
				<TimeHolderComponent
					time={showCalendarTime ? message.time.calendar() : formatLadderTime(message.time, 'clock')}
					title={formatLadderTime(message.time, 'full')}
					onClick={onTimeHolderClick}
				/>
				<HealthComponent user={message.player} message={message} />
				<span> </span>
				<span className='user_things'>
	                    <span className='username_and_such'>
		                    {/* Standard shows the avatar in the gutter, Compact the stock icon inline. */}
		                    <ChatAvatar player={message.player} character={senderMain} />
		                    <CharacterStockIcon character={senderMain} />
		                    {fromMatchModerator &&
		                    <span className='chat_message__moderator-tag' data-testid='moderator-tag'>
			                    <i className='fa fa-shield' aria-hidden='true' />
			                    {__('MOD')}
		                    </span>
		                    }
	                        <UserComponent
		                        onClick={chatUsernameClick}
		                        user={message.player}
		                        showFrontFlair={showFrontFlair}
		                        flair={showFlair}
		                        flairAfterName={true}
		                        avatarAsFlair={false}
		                        isChatMod={message.isChatMod()}
		                        showDisplayName={true}
		                        showTopDonatorFlair={true}
		                        showIsNew={true}
		                        slippiName={chatMessages?.shouldShowSlippiName()}
	                        />
		                    <span className='colon'>:</span>
	                        <span> </span>
	                    </span>
		                {isIgnored &&
		                <span
			                className='ignored_badge'
			                data-tip={`You blocked ${message.player.username}. You still see their messages because you moderate this chat.`}
			                data-for={`ignored-badge-${message.id}`}
		                >Blocked</span>
		                }
		                {lfg &&
		                <LfgCard message={messageData} />
		                }
		                {!lfg &&
		                <PlayerMessageTextComponent
			                chatMessages={chatMessages}
			                setChatMessageToEditMode={setChatMessageToEditMode}
			                endChatMessageEditMode={endChatMessageEditMode}
			                submitMessageEdit={submitMessageEdit}
			                message={messageData}
			                isEditing={isEditing}
			                submittingUpdate={submittingUpdate}
			                messageReact={submittingUpdate ? LadderLinker.autolinkMessage({ message: submittingUpdate.text }, true) : messageReact}
			                displayMannersWarning={displayMannersWarning}
			                displayScamWarning={displayScamWarning}
		                />
		                }
		                <ReactionPillsComponent message={messageData} />
		                {connectCodeOffer &&
		                <ConnectCodeOfferCard offer={connectCodeOffer} />
		                }
	                </span>
				{showToolbar &&
				<MessageHoverToolbar onQuickReact={quickReact} onOpenMenu={launchContextMenu} />
				}
			</div>
			{isIgnored &&
			<ReactToolTip id={`ignored-badge-${message.id}`} type='dark' effect='solid' place='bottom' />
			}
		</React.Fragment>
	);
}

const defaultProps = {
	showFrontFlair: true,
	showFlair: true,
};